export const fixSmoothDndNodePrototypeBug = () => {
  // 背景：https://bytedance.feishu.cn/docx/Vcu4dkptFossFlxZAppcWPjTnUa
  // 已提 pr：https://github.com/kutlugsahin/smooth-dnd/pull/92
  // 目的是先发制人，让源码里错误的 defineProperty 没办法执行
  (function (constructor) {
    if (
      constructor &&
      constructor.prototype &&
      !Object.prototype.hasOwnProperty.call(constructor.prototype, 'firstElementChild')
    ) {
      Object.defineProperty(constructor.prototype, 'firstElementChild', {
        get() {
          // 实例才可以调用 childNodes，所以在此处限制
          if (this !== constructor.prototype) {
            let node;
            const nodes = this.childNodes;
            let i = 0;
            while ((node = nodes[i++])) {
              if (node.nodeType === 1) {
                return node;
              }
            }
            return null;
          }
          return '';
        },
      });
    }
  })(Node || Element);
};
